import { Inject, Injectable } from '@angular/core';
import { map } from 'lodash';

import { UserModel } from '@lockton-apps/client-gateway/interfaces';
import { User, UserCreate, UserUpdate } from '@lockton-apps/shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class UsersTransformationsService {
  constructor(
    @Inject('AZURE_STORAGE_ACCOUNT_NAME') private storageAccountName: string
  ) {}

  userCreate(userModel: UserModel): UserCreate {
    // if (!this.checkUndefined(userModel)) {
    //   throw new Error('User form transformation error');
    // }

    const {
      language,
      role,
      givenName,
      surname,
      email,
      phoneNumber,
      description,
      brokerT2Codes,
      profileImage,
    } = userModel;

    if (!role || !givenName || !surname || !email || !language) {
      throw new Error('User form transformation error');
    }

    const additionalProps = {
      displayName: `${givenName} ${surname}`,
      imageStorageAccount: this.storageAccountName,
    };

    return {
      role,
      givenName,
      surname,
      email,
      phoneNumber,
      description,
      brokerT2Codes: brokerT2Codes || [],
      profileImage,
      language,
      ...additionalProps,
    };
  }

  userUpdate(user: UserModel, userId: string): UserUpdate {
    return { userId, ...this.userCreate(user), enabled: true };
  }

  userModel(user: User): UserModel {
    return {
      language: user.language,
      role: user.role,
      givenName: user.givenName,
      surname: user.surname,
      email: user.email,
      phoneNumber: user.phoneNumber,
      profileImage: null,
      brokerT2Codes: map(user.t2Codes, (u) => u.id),
      description: user.description,
    };
  }

  userToUserUpdate(user: User): UserUpdate {
    return this.userUpdate(this.userModel(user), user.userId);
  }
}
